import {
  useGetEmcStandardsRecommendations,
  useReplaceEmcConfirmedStandards,
} from '@/shared/hooks/api/emcComplianceFiles'
import { ConfirmedHarmonisedStandardsEditSheet } from '@/v2/components/product-compliance-briefing/ConfirmedHarmonisedStandardsEditSheet'
import type { ConfirmedHarmonisedStandard } from '@/v2/lib/confirmedHarmonisedStandards'

type V2EmcConfirmedStandardsEditSheetProps = {
  productId: string
  standards: ConfirmedHarmonisedStandard[]
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function V2EmcConfirmedStandardsEditSheet({
  productId,
  standards,
  open,
  onOpenChange,
}: V2EmcConfirmedStandardsEditSheetProps) {
  const { mutateAsync: replaceStandards, isPending: isSaving } =
    useReplaceEmcConfirmedStandards(productId)
  const {
    mutateAsync: fetchRecommendations,
    isPending: isLoadingRecommendations,
  } = useGetEmcStandardsRecommendations(productId)

  return (
    <ConfirmedHarmonisedStandardsEditSheet
      standards={standards}
      open={open}
      onOpenChange={onOpenChange}
      i18nKeyPrefix='v2.pages.products.detail.emcBriefing.confirmedStandards'
      isSaving={isSaving}
      isLoadingRecommendations={isLoadingRecommendations}
      onSave={async (nextStandards) => {
        await replaceStandards({ standards: nextStandards })
      }}
      onFetchRecommendations={async () => {
        const result = await fetchRecommendations()
        return result.standards
      }}
    />
  )
}
